import apiClient, { monitorVitalsApi } from "../../.../../../http-common";
import authHeader from "../../../authentication/authservices/auth-header";

export const getMonitorVitalsList = (postObj) => {
  return monitorVitalsApi.post(`/monitordata/vitals`, postObj, {
    // headers: authHeader(),
  });
};

export const saveMonitorVital = (postObj) => {
  return monitorVitalsApi.post(`/monitordata/saveVitals`, postObj, {
    // headers: authHeader(),
  });
};
